import type { useResgate } from '@/login/composables/useResgate';
import { useLoginStore } from '@/login/stores/useLoginStore';
import type { PerformanceAssessmentKeyValues, PublishStatus } from '@sysarb/sysarb-types/services/v1/pay-management';

/**
 * Get Review by draft id
 *  @param reviewId Salary review id
 */
export async function getPerformanceAssessmentOverviewKeyValues(resgate: ReturnType<typeof useResgate>, reviewId: string): Promise<PerformanceAssessmentKeyValues | null> {
    const { instanceTopic } = useLoginStore();
    const promise = resgate.model<PerformanceAssessmentKeyValues>(`v1.pay-management.subdomain.${instanceTopic}.performance-assessment.${reviewId}.overviewkeyvalues`).then(res => {
        if (res?.success === false) return null;
        return res.data;
    });
    return promise;
}

/**
 * Get budget status
 * @param reviewId Review id
 */
export async function getPerformanceAssessmentPublishStatus(resgate: ReturnType<typeof useResgate>, reviewId: string): Promise<PublishStatus | null> {
    const promise = resgate.call<PublishStatus>(`v1.pay-management.performance-assessment.${reviewId}`, 'publishstatus', {}).then(res => {
        if (res?.success === false) return null;
        return res.data;
    });
    return promise;
}
